import clsx from "clsx";
import { useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { useRouter } from "@/app/hooks/useRouter";
import useRouteInfo from "@/app/hooks/useRouteInfo";
import RBACFlag from "@/app/components/core/RBACFlag";
import { useConstants } from "@/app/hooks/useConstants";
import { VMSMappedObjectConstantsType } from "@/constants";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import SolidButton from "@/app/components/ui/Buttons/SolidButton";
import SetupStandardShiftComponent from "./SetupStandardShiftComponent";
import { useRotaShiftListAPI } from "@/app/hooks/api_hooks/Rota/useRotaShiftListAPI";
import { useRotaShiftStatsAPI } from "@/app/hooks/api_hooks/Rota/useRotaShiftStatsAPI";
import { IRotaState, setShiftDetails } from "@/app_redux/reducers/slices/auth/rota_slice";

const HeaderComponent = () => {
  const { getRouteKey } = useRouter();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [activeStat, setActiveStat] = useState<"0" | "1">("0");
  const fetchStatsListAPI = useRotaShiftStatsAPI();
  const fetchShiftListAPI = useRotaShiftListAPI();
  const { rotaManagementConstant } = useConstants("MAPPED") as VMSMappedObjectConstantsType;
  const { routeState } = useRouteInfo(getRouteKey("ROTA", "id"));
  const { shiftStats } = routeState.state as IRotaState;

  useEffect(() => {
    fetchStatsListAPI();
    fetchShiftListAPI(true);
  }, []);

  const handelAddNavigate = () => {
    navigate(`/app/rota/shift-add`);
    dispatch(setShiftDetails({ data: null }));
  };

  return (
    <div className="px-5 py-3">
      <div>
        <div>
          <div>
            <h1 className="font-semibold text-sm">{rotaManagementConstant?.standardShift}</h1>
          </div>
          <div className="flex justify-between items-end mt-2">
            <div className="flex gap-4">
              <div
                onClick={() => {
                  setActiveStat("0");
                  fetchShiftListAPI(true);
                }}
                className={clsx(
                  "p-4 border rounded-lg w-[12rem] h-[5rem] cursor-pointer",
                  activeStat === "0" ? "border-[#0068FF]" : "border-[rgba(128, 141, 160]",
                )}
              >
                <p className={clsx("text-base", activeStat === "0" ? " text-[#0068FF]" : "text-black")}>
                  {shiftStats?.active_shift}
                </p>
                <h2 className="text-xs">{rotaManagementConstant?.activeShift}</h2>
              </div>
              <div
                onClick={() => {
                  setActiveStat("1");
                  fetchShiftListAPI(false);
                }}
                className={clsx(
                  "p-4 border rounded-lg w-[12rem] h-[5rem] cursor-pointer",
                  activeStat === "1" ? "border-[#0068FF]" : "border-[rgba(128, 141, 160]",
                )}
              >
                <p className={clsx("text-base", activeStat === "1" ? " text-[#0068FF]" : "text-black")}>
                  {shiftStats?.inactive_shift}
                </p>
                <h2 className="text-xs">{rotaManagementConstant?.inActiveShift}</h2>
              </div>
            </div>
            <div>
              <RBACFlag actionId="SHIFT_ADD">
                <SolidButton onButtonClick={() => handelAddNavigate()} size="XL">
                  {rotaManagementConstant?.addNewShift}
                </SolidButton>
              </RBACFlag>
            </div>
          </div>
        </div>
      </div>
      <SetupStandardShiftComponent setActiveStat={setActiveStat} />
    </div>
  );
};
export default HeaderComponent;
